import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

export default function BarChart({ data, labels }) {
  return (
    <div id="chart">
      <ReactApexChart
        options={{
          xaxis: {
            categories: [
              labels[0].name,
              labels[1].name,
              labels[2].name,
              labels[3].name,
              labels[4].name,
              labels[5].name,
              labels[6].name,
              labels[7].name,
              labels[8].name,
              labels[9].name,
              labels[10].name,
              labels[11].name,
              labels[12].name,
            ],
          },
          labels: {
            show: true,
            formatter(val) {
              return val;
            },
          },
          dataLabels: {
            enabled: true,
            formatter(val) {
              return val;
            },
            style: {
              fontSize: '12px',
              colors: ['#000000', '#333333', '#ffffff'],
            },
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          fill: {
            colors: ['#3ec4b8', '#3ec4b8', '#3ec4b8'],
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        }}
        series={[
          {
            name: 'Total',
            data: [
              data[0]['0'].count,
              data[1]['0'].count,
              data[2]['0'].count,
              data[3]['0'].count,
              data[4]['0'].count,
              data[5]['0'].count,
              data[6]['0'].count,
              data[7]['0'].count,
              data[8]['0'].count,
              data[9]['0'].count,
              data[10]['0'].count,
              data[11]['0'].count,
              data[12]['0'].count,
            ],
          },
        ]}
        type="bar"
        height="350"
      />
    </div>
  );
}

BarChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.string,
  }))).isRequired,
};
